import React from 'react';
import './ChipList.less';

//TODO add horizontal scroll on overflow

export const ChipList = ({children}) => {
	return (
		<ul className="chip-list">
			{children.map(child => (
				<li className="chip-list__item" key={child.key}>
					{child}
				</li>
			))}
		</ul>
	);
};
